<template>
  <v-tooltip v-if="texto" bottom max-width="320">
    <template v-slot:activator="{ on, attrs }">
      <v-icon x-small class="ml-1 dica-metrica" :color="cor" v-bind="attrs" v-on="on" @click.stop
        >mdi-information-outline</v-icon
      >
    </template>
    <span>{{ texto }}</span>
  </v-tooltip>
</template>

<script>
/**
 * Icone de informacao com a explicacao de uma metrica (textos em
 * descricoesMetricas.js). O click.stop evita que, no cabecalho de uma tabela,
 * o clique no icone ordene a coluna.
 */
export default {
  name: "DicaMetrica",
  props: {
    texto: { type: String, default: "" },
    cor: { type: String, default: "grey" },
  },
};
</script>

<style scoped>
.dica-metrica {
  cursor: help;
  vertical-align: middle;
}
</style>
